import api from "./api";

export default {
  // USERS

  fetchUser(apiKey, godCredentials) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: "users/self",
          api_key: apiKey,
          godCredentials
        },
        (err, response) => {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchCondensedUsers(apiKey) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: "users/condensed",
          api_key: apiKey
        },
        (err, response) => {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchPaginatedUsers(apiKey, page, isContentCreators, sorted, searchTerm) {
    return new Promise((resolve, reject) => {
      let sortingQuery = "";

      if (sorted && sorted.length !== 0) {
        sortingQuery = `&sortedId=${sorted[0].id}&sortedIsDesc=${sorted[0].desc}`;
      }

      api.request(
        {
          method: "GET",
          endpoint: `users/paginated?page=${page}&${
            isContentCreators
              ? "only_content_creators=true"
              : "exclude_content_creators=true"
          }${sortingQuery}${searchTerm ? `&searchTerm=${searchTerm}` : ""}`,
          api_key: apiKey
        },
        (err, response) => {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  editUser(apiKey, user, data) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `users/${user}`,
          json: data,
          api_key: apiKey
        },
        (err, response) => {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  createUser(apiKey, data) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `users`,
          json: data,
          api_key: apiKey
        },
        (err, response) => {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  makeApiKey(apiKey, data) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `users/self/api_keys`,
          json: data,
          api_key: apiKey
        },
        (err, response) => {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  deleteApiKey(apiKey, keyToDelete) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "DELETE",
          endpoint: `users/self/api_keys/${keyToDelete}`,
          api_key: apiKey
        },
        (err, response) => {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  signup(options) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: "user_signup",
          json: options
        },
        (err, response) => {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  lookupContentCreatorInvite(apiKey, token) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: "content_creator_invite/lookup",
          json: { token },
          api_key: apiKey // optional, only for logged in lookup
        },
        (err, response) => {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  acceptContentCreatorInvite(apiKey, options) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: "content_creator_invite/accept",
          json: { token: options.token, title: options.title },
          api_key: apiKey
        },
        (err, response) => {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  lookupRevenueSharingInvite(token) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: "revenue_sharing/invite/lookup",
          json: { token }
        },
        (err, response) => {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  acceptRevenueSharingInvite(apiKey, token) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: "revenue_sharing/invite/accept",
          json: { token },
          api_key: apiKey
        },
        (err, response) => {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  uploadFile(apiKey, key, file, options) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `files`,
          json: options,
          fileField: key,
          file: file,
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  // GOD MODE

  fetchAllUsers(apiKey, { excludeContentCreators, onlyContentCreators } = {}) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `users${
            excludeContentCreators
              ? `?exclude_content_creators=true`
              : onlyContentCreators
              ? "?only_content_creators=true"
              : ""
          }`,
          api_key: apiKey
        },
        (err, response) => {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  deleteUser(apiKey, user) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "DELETE",
          endpoint: `users/${user}`,
          api_key: apiKey
        },
        (err, response) => {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  // ROLES

  fetchRoles(apiKey) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: "accounts/roles",
          api_key: apiKey
        },
        (err, response) => {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  // ACCOUNTS

  login(email, password, noRedirect) {
    return new Promise((resolve, reject) => {
      if (!email || !password) {
        return reject(new Error("An email address and password are required."));
      }

      api.request(
        {
          method: "POST",
          endpoint: "accounts/login",
          json: { email, password },
          ignoreLoginErrors: noRedirect
        },
        (err, response) => {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchOwnAccount(apiKey) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: "accounts/self",
          api_key: apiKey
        },
        (err, response) => {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchAccounts(apiKey) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: "accounts",
          api_key: apiKey
        },
        (err, response) => {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  editAccount(apiKey, account, data) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `accounts/${account}`,
          json: data,
          api_key: apiKey
        },
        (err, response) => {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  createAccount(apiKey, data) {
    return new Promise((resolve, reject) => {
      if (!data.email || !data.password) {
        return reject(new Error("An email address and password are required."));
      }

      api.request(
        {
          method: "POST",
          endpoint: `accounts`,
          json: data,
          api_key: apiKey
        },
        (err, response) => {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  deleteAccount(apiKey, account) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "DELETE",
          endpoint: `accounts/${account}`,
          api_key: apiKey
        },
        (err, response) => {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  forgotPassword(email) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: "accounts/forgot_password",
          json: {
            email: email,
            reset_url:
              window.location.protocol +
              "//" +
              window.location.host +
              "/reset?token="
          },
          ignoreLoginErrors: true
        },
        (err, response) => {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  resetPassword(token, password) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: "accounts/reset_password",
          ignoreLoginErrors: true,
          json: {
            token: token,
            password: password
          }
        },
        (err, response) => {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  // OTHER

  generateVirtualActivationLink({ apiKey }) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: "activations/generate_link",
          api_key: apiKey
        },
        (err, response) => {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  generateVirtualManagementLink({ apiKey, next }) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: "activations/generate_billing_management_link",
          json: { next },
          api_key: apiKey
        },
        (err, response) => {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/utils/UserUtil.js